import { html, render, TemplateResult } from "lit";
import { isBuffer } from "lodash";
import { JobCertificateLog } from "../data/job-certificate";
import { getCertificateDetails, JobItem, runCertificateRequest, setCertificateDetails } from "../data/search-data";
import { getModalLauncher } from "./modal-wrapper";



export class JobCertificateModal {
    private viewContainer: HTMLElement | null;
    private job: JobCertificateLog;
    //the container we render into
    ui: HTMLDivElement;
    private data: JobItem[];

    sending: any;

    constructor(data: JobItem[]) {
        this.data = data;

        this.ui = this.newDiv();
        this.viewContainer = null;
        this.job = getCertificateDetails();
        this.job.locality = "";
        this.job.siteAddress = "";
        this.job.state = "";
        this.job.items =
            data.map(x => {
                return {
                    windowId: x.displayRow.windowId,
                    manufacturer: x.displayRow.manufacturer,
                    frameDescription: x.displayRow.frameDescription,
                    frameMaterial: x.displayRow.frameMaterial,
                    operatingType: x.displayRow.operatingType,
                    glassDescription: x.displayRow.glazingDisplayName,
                    uw: x.displayRow.uw,
                    sghcw: x.displayRow.shgc,
                    tvw: x.displayRow.tvw,
                    ai: x.displayRow.ai
                };
            });
    }
    private newDiv(): HTMLDivElement {
        const result = document.createElement('div');
        result.className += " jobcertificate-editor";
        return result;
    }

    private render() {
        render(this.template(), this.ui);
    }
    protected footerTemplate(): TemplateResult {

        const okButton = this.sending
            ? html`
            <button type="button" class="btn btn-primary">Sending...
                <div class="spinner-border text-light" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </button>`
            : html`<button type="button" class="btn btn-primary" @click=${async ()=> await this.ok()}>Send</button>`;

        const cancelButton =
            this.sending
                ? html``
                : html`<button type="button" class="btn btn-primary" @click=${() => this.cancel()}>Cancel</button>`;

        return html`${okButton}${cancelButton}`;

    }
    cancel() {
        this.hideModal();
    }

    private fieldValidTemplate(field: string): TemplateResult {
        let value = this.job[field] ?? "";
        if (value !== "") return html``;
        return html`<div class="col-1"><i class=" fas fa-asterisk text-danger"></i></div>`;

    }

    private template(): TemplateResult {
        const job = this.job;
        let requiredTemplate =
            this.valid() ? html`` : html`<p class="text-danger"><b><i class="fas fa-asterisk text-danger"></i> All fields are required</b></p>`;


        return html`
            <div class="modal" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Request Certificate</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            ${requiredTemplate}
                            <div class="mb-3 row">
                                <label for="edit-client" class="col-form-label col-3">Your Company/Name</label>
                                <div class="col-8">
                                    <input type="text" class="form-control " id="edit-client" .value=${job.client}
                                        ?readonly=${this.sending} />
                                </div>
                                ${this.fieldValidTemplate('client')}
                            </div>
                            <div class="mb-3 row">
                                <label for="edit-address" class="col-form-label col-3">Site Address</label>
                                <div class="col-8">
                                    <input type="text" class="form-control " id="edit-siteaddress" .value=${job.siteAddress}
                                        ?readonly=${this.sending} />
            
                                </div>
                                ${this.fieldValidTemplate('siteAddress')}
                            </div>
                            <div class="mb-3 row">
                                <label for="edit-locality" class="col-form-label col-3">City/Suburb</label>
                                <div class="col-8"><input type="text" class="form-control " id="edit-locality"
                                        .value=${job.locality} ?readonly=${this.sending} />
            
                                </div>
                                ${this.fieldValidTemplate('locality')}
                            </div>
                            <div class="mb-3 row">
                                <label for="edit-state" class="col-form-label col-3">State</label>
                                <div class="col-8">
                                    <select placeholder="Select your state from the dropdown list" class="form-control "
                                        id="edit-state" .value=${job.state} ?readonly=${this.sending} ?disabled=${this.sending}>
                                        <option value="" disabled selected>Select your State</option>
                                        <option value="NSW">New South Wales</option>
                                        <option value="QLD">Queensland</option>
                                        <option value="VIC">Victoria</option>
                                        <option value="WA">Western Australia</option>
                                        <option value="TAS">Tasmania</option>
                                        <option value="SA">South Australia</option>
                                        <option value="ACT">Australian Captial Territory</option>
                                        <option value="NT">Northern Territory</option>
                                    </select>
                                </div>
                                ${this.fieldValidTemplate('state')}
                            </div>
                            <div class="mb-3 row">
                                <label for="edit-createdby" class="col-form-label col-3">Your Name</label>
                                <div class="col-8">
                                    <input type="text" class="form-control " id="edit-createdby" .value=${job.createdBy}
                                        ?readonly=${this.sending} />
            
                                </div>
                                ${this.fieldValidTemplate('createdBy')}
                            </div>
                            <div class="mb-3 row">
                                <label for="edit-emailaddress" class="col-form-label col-3">Email Address</label>
                                <div class="col-8">
                                    <input type="text" class="form-control " id="edit-emailaddress" .value=${job.emailAddress}
                                        ?readonly=${this.sending} />
            
                                </div>
                                ${this.fieldValidTemplate('emailAddress')}
                            </div>
                        </div>
                        <div class="modal-footer">
                            ${this.footerTemplate()}
                        </div>
                    </div>
                </div>
            </div>`;
    }


    protected async ok() {
        const getVal = (field: string): string => {
            let value = (this.ui.querySelector(`#edit-${field.toLowerCase()}`) as any).value as string;
            if (!value) return "";
            return value;
        };

        this.job.client = getVal('client');
        this.job.createdBy = getVal('createdBy');
        this.job.emailAddress = getVal('emailAddress');
        this.job.locality = getVal('locality');
        this.job.siteAddress = getVal('siteAddress');
        this.job.state = getVal('state');

        if (!this.valid()) {
            this.render();
            return;
        }

        this.sending = true;
        this.render();
        try {
            await runCertificateRequest(this.job);
            setCertificateDetails(this.job);
            this.hideModal();
        }
        catch (e: any) {
            alert(e.message);
        }
        finally {
            this.sending = false;
            this.render();
        }

    }
    valid(): boolean {
        return this.job.client !== ""
            && this.job.createdBy !== ""
            && this.job.emailAddress !== ""
            && this.job.locality !== ""
            && this.job.state !== ""
            && this.job.siteAddress !== "";

    }
    public showModal() {
        if (!this.container) this.container = document.body;
        const modalDialog = this.ui.firstElementChild as HTMLElement;
        getModalLauncher().show(modalDialog);
        modalDialog.addEventListener("hidden.bs.modal", () => this.ui.remove());
    }
    public hideModal() {
        const modalDialog = this.ui.firstElementChild as HTMLElement;
        getModalLauncher().hide(modalDialog);
    }

    public set container(parent: HTMLElement | null) {
        //if we are already attached to a parent then detach ourselves
        if (this.viewContainer && this.ui) {
            this.viewContainer.removeChild(this.ui);
        }
        this.viewContainer = parent;
        if (this.viewContainer) {
            this.viewContainer.appendChild(this.ui);
            // we need to ensure we have the child elements built
            this.render();
        } else {
            this.ui = this.newDiv();
        }
    }
    public get container(): HTMLElement | null {
        return this.viewContainer;
    }
}
